import React from "react";
import styled, { css } from "styled-components";
import Container from "./Container";
import Section from "./Section";
import { Link } from "gatsby";
import { HtmlContent } from "./Content";

const ListStyles = styled.ul`
  ${({ ...props }) => css`
    text-align: center;
    @media (min-width: ${props.theme.breakpoints.md}) {
      column-count: 2;
    }
    @media (min-width: ${props.theme.breakpoints.lg}) {
      column-count: 4;
    }
  `}
`;

export const LocationList = ({ products }) => {
  if (
    products.filter((product) => product.productData.location === true).length < 1
  ) {
    return;
  }
  return (
    <Section
      heading="Some of the areas we cover"
      subHeading="Including, but not limited to..."
    >
      <Container>
        <ListStyles>
          {products
            .sort(function (a, b) {
              return a.menuOrder - b.menuOrder;
            })
            .map((product) => {
              if (!product.productData.location) {
                return;
              }
              return (
                <li key={product.id}>
                  <Link to={product.uri}>
                    <HtmlContent htmlString={product?.productData?.productTitleSimple || product.title} />
                  </Link>
                </li>
              );
            })}
        </ListStyles>
      </Container>
    </Section>
  );
};
